/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ClearanceCaseUpdateDocumentsResponseJson } from './clearance-case-update-documents-response-json';
import { ClearanceCaseUpdateDocumentsResult } from '../results/clearance-case-update-documents-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ClearanceCaseUpdateDocumentsResponse extends ResponseWithErrorGeneric<ClearanceCaseUpdateDocumentsResponseJson, ClearanceCaseUpdateDocumentsResult> implements IResponseWithErrorGeneric<ClearanceCaseUpdateDocumentsResult> {
  public clearanceCaseId: string = undefined;
  public clearanceCase: ClearanceCaseDto;

  //<custom-body>
  constructor(response: HttpResponse<ClearanceCaseUpdateDocumentsResponse>) {
    super(response, ClearanceCaseUpdateDocumentsResult.Error);
    if (this.result === ClearanceCaseUpdateDocumentsResult.Success) {
      this.clearanceCaseId = this.body.clearanceCaseId;
    }
  }
  //</custom-body>
}
